<script setup lang="ts">
import PlanTag from '@/atoms/PlanTag.vue'
import NitWarningMessage from '@/components/NitWarningMessage.vue'
import { useTeamStore } from '@/store/teamStore'
import { useUserPlanStore } from '@/store/userPlanStore'
import { PRO_PLAN_PRICE } from '@WombatTechnology/nitte-time-lib'

const userPlanStore = useUserPlanStore()
const { userPlan, cancelAtFormatted, isProPlanCanceled } =
  storeToRefs(userPlanStore)

const teamStore = useTeamStore()
const { belongsToTeam } = storeToRefs(teamStore)
</script>

<template>
  <strong-g class="pd-rect lo-v">
    <PlanTag :type="'pro'"> プロ </PlanTag>
    <main-title class="lo-h-baseline">
      {{ PRO_PLAN_PRICE }}円<description>/月(税込)</description>
    </main-title>
    <NitWarningMessage v-if="belongsToTeam" class="mg-top-8px">
      <sup-description>
        チームに所属している場合は、プロプランを利用できません。
      </sup-description>
    </NitWarningMessage>
    <div v-if="userPlan === 'pro'">
      <sup-label :disabled="true" class="t-12px" :width="'160px'">
        現在のプラン
      </sup-label>
      <description v-if="isProPlanCanceled">
        {{ cancelAtFormatted }}まで
      </description>
    </div>
  </strong-g>
</template>
